import { useContext, type CSSProperties, type ReactNode, type Ref } from "react";
import { BLASEN_FORM, type BlasenForm, type SatzTeil } from "./blasenForm";
import { SprecherKontext } from "./kontext";

/** Satz aus Teilen; Signalwörter als `em.signal` mit `data-signal`. */
export function Satz(props: { teile: SatzTeil[] }) {
  return (
    <>
      {props.teile.map((t, i) =>
        t.signal ? (
          <em key={i} className="signal" data-signal={t.signal}>
            {t.betont ? <b>{t.text}</b> : t.text}
          </em>
        ) : t.betont ? (
          <b key={i}>{t.text}</b>
        ) : (
          <span key={i}>{t.text}</span>
        ),
      )}
    </>
  );
}

/** Blase des Geists (Sprecher-Regel): nur an einer Figur, also nur in einer Geist-Szene, der Geist-Ebene oder am
 *  Randgeist; ohne Figur zeigt sie nichts. Neue Sätze werden höflich angesagt. */
export function Blase(props: {
  form: BlasenForm;
  satz?: SatzTeil[];
  /** Schriftstufe des Satzes, etwa `w-satz-akten` in der Akten-Szene */
  stufe?: string;
  label?: string;
  className?: string;
  style?: CSSProperties;
  ref?: Ref<HTMLDivElement>;
  children?: ReactNode;
}) {
  const { ref } = props;
  const sprecher = useContext(SprecherKontext);
  if (!sprecher) return null;
  const form = BLASEN_FORM[props.form];
  return (
    <div
      ref={ref}
      role="group"
      aria-label={props.label ?? "Der Briefgeist sagt"}
      className={`blase glas ${props.className ?? ""}`}
      data-form={props.form}
      data-spitze={form.spitze}
      data-sprecher={sprecher}
      data-schwebend={form.schwebend ? "" : undefined}
      style={{ transformOrigin: form.ursprung, ...props.style }}
    >
      {props.satz && (
        <p className={`blase-satz ${props.stufe ?? form.stufe}`} aria-live="polite">
          <Satz teile={props.satz} />
        </p>
      )}
      {props.children}
    </div>
  );
}
